import { DownloadIcon } from 'lucide-react';
import { useLocale, useTranslations } from 'use-intl';
import type { Site } from '@/features/branding/brand-provider';

/**
 * Slim link to the stats export, below the dashboard grid. Points straight at
 * the backend export (cookie-authenticated); the backend expands a portfolio
 * id to its locations and sends the xlsx as an attachment.
 */
export function DownloadStatsLink({ site }: { site: Site }) {
  const t = useTranslations('stats');
  const locale = useLocale();
  const params = new URLSearchParams({ location: String(site.id), locale });
  return (
    <div className="mx-auto mt-6 flex max-w-screen-2xl justify-end">
      <a
        href={`/api/v1/exports/statistics?${params.toString()}`}
        download="statistics.xlsx"
        className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 text-sm underline-offset-4 hover:underline"
      >
        <DownloadIcon className="size-4" /> {t('download_stats')}
      </a>
    </div>
  );
}
